import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { showAllErrors } from 'pages/dashboard/components/Progress/progressSlice';
import { getProcent } from 'pages/dashboard/components/Progress/selectors';
import { getPermissions } from 'pages/dashboard/selectors';
import { fetchProfileByEmail } from 'pages/Profile/thunks';
import { useAppDispatch, useAppSelector } from 'hooks';
import { PermissionSchema } from 'services/security';
import { getPerson } from 'pages/Profile/selectors';
import { Permissions } from 'entities/dashboard';
import Button from 'components/Button';

import { getIsSaving } from 'pages/dashboard/components/BusinessInformation/selectors';
import OatFiOnboardingModal from './components/OatFiOnboardingModal';
import InformationMissing from './components/InformationMissing';
import { getShowOatFiOnboardingModal } from './selectors';
import SubmitModal from './components/SubmitModal';
import {
  setIsModalOpened,
  setShowOatFiOnboardingModal,
} from './submitDashboardSlice';

const SubmitDashboard = () => {
  const { t } = useTranslation('dashboard');
  const dispatch = useAppDispatch();

  const [showWarning, setShowWarning] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const showOatFiOnboardingModal = useAppSelector(getShowOatFiOnboardingModal);
  const permissions = useAppSelector(getPermissions);
  const appPercent = useAppSelector(getProcent);
  const person = useAppSelector(getPerson);
  const isSaving = useAppSelector(getIsSaving);

  const handleWarning = async () => {
    setShowWarning(true);
    await dispatch(showAllErrors());
    const tabWithError = Array.from(document.querySelectorAll('.tab')).find(
      (tab) => tab.querySelector('.icon-error'),
    );

    tabWithError?.dispatchEvent(new MouseEvent('click', { bubbles: true }));
  };

  const handleOpen = () => {
    const saveButton =
      document.querySelector<HTMLButtonElement>('.btn-save-changes');

    if (saveButton && !saveButton.disabled) {
      setIsLoading(true);
      saveButton?.click();
      return;
    }

    if (!appPercent || appPercent < 100) {
      handleWarning();
      return;
    }

    dispatch(setIsModalOpened(true));
  };

  const handleCloseOatFiModal = async () => {
    dispatch(fetchProfileByEmail(person.emailAddress));
    dispatch(setShowOatFiOnboardingModal(false));
  };

  useEffect(() => {
    if (isLoading && !isSaving) {
      handleOpen();
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isSaving]);

  if (
    !permissions.find(
      (p: PermissionSchema) => p.permissions_Code === Permissions.submitApp,
    )
  ) {
    return null;
  }

  return (
    <>
      <SubmitModal onWarning={handleWarning} />
      {showOatFiOnboardingModal && (
        <OatFiOnboardingModal onClose={handleCloseOatFiModal} />
      )}
      <InformationMissing
        showWarning={showWarning}
        setShowWarning={setShowWarning}
      />
      <Button
        onClick={handleOpen}
        type="button"
        className="flex-shrink-0 ml-6"
        heightClass="h-10.5"
        paddingClass="px-5"
        loading={isLoading}
      >
        {t('dashboard:nextStep')}
      </Button>
    </>
  );
};

export default SubmitDashboard;
